import { call, put } from 'typed-redux-saga/macro';

import { getRoute } from 'Config';
import type { GetActionByType } from 'Lib/reduxType';
import { withErrorHandling } from 'Lib/sagaHelpers';
import { getServiceFn } from 'Services';
import { OFFER_SERVICE } from 'Services/constants';

import { showNotification } from 'Store/notifications/actions';
import { fetchProfile } from 'Store/profile/actions';

import { ICON_ALERT_TRIANGLE, ICON_TINDER } from 'Containers/Notification/icons.types';
import {
  NOTIFICATION_THEME_DARK,
  NOTIFICATION_THEME_ERROR,
} from 'Components/InAppNotification/constants';

import { setOfferSeenSuccess } from './actions';
import { CLAIM_OFFER, SET_OFFER_SEEN } from './constants';

// Ref: https://github.com/TinderBackend/stacks/blob/main/lib/error_codes.js#L200
const MISSING_PAYMENT_METHOD_ADYEN = 40048;

export const claimOfferSaga = withErrorHandling(
  function* _claimOfferSaga(action: GetActionByType<typeof CLAIM_OFFER>) {
    yield* call(
      yield* call(getServiceFn, OFFER_SERVICE, 'claimOffer' as const),
      action.payload.data
    );
    yield* put(
      showNotification({
        icon: ICON_TINDER,
        theme: NOTIFICATION_THEME_DARK,
        title: [{ id: 'Notification.offerRedeemed' }],
        body: [{ id: 'Notification.nextMonthDiscountApplied' }],
        options: {
          route: '',
          ttl: 8000,
        },
      })
    );
    // Call profile API to refresh the purchases and offerings
    yield* put(fetchProfile());
  },
  {
    name: 'claimOfferSaga',
    *errorHandler(e: any) {
      if (e.error.code === MISSING_PAYMENT_METHOD_ADYEN) {
        yield* put(
          showNotification({
            icon: ICON_ALERT_TRIANGLE,
            theme: NOTIFICATION_THEME_ERROR,
            title: [{ id: 'Notification.creditCardInfoMissing' }],
            body: [{ id: 'Notification.addNewCard' }],
            options: {
              route: getRoute('updateCard', { returnPage: 'accountSettings' }),
            },
          })
        );
      } else {
        yield* put(
          showNotification({
            icon: ICON_ALERT_TRIANGLE,
            theme: NOTIFICATION_THEME_ERROR,
            title: [{ id: 'uhOhSomethingWentWrong' }],
            body: [{ id: 'pleaseTryAgain' }],
          })
        );
      }
    },
  }
);

export const setOfferSeenSaga = withErrorHandling(
  function* _setOfferSeenSaga(action: GetActionByType<typeof SET_OFFER_SEEN>) {
    const payload = yield* call(
      yield* call(getServiceFn, OFFER_SERVICE, 'setOfferSeen' as const),
      action.payload.data
    );
    if (payload) {
      yield* put(setOfferSeenSuccess({ ...payload.data, offerType: action.payload.offerType }));
      // Call profile API in case there is no expiresAt stored inside the sub offer product just yet
      // to prevent the countdown from disappearing and re-appearing.
      yield* put(fetchProfile());
    }
  },
  { name: 'setOfferSeenSaga' }
);
